<!-- components/NewContentBottomList.svelte -->
<script>
  import { locale } from "../libs/i18n";

  let newContent1Src;
  let newContent2Src;

  $: if ($locale) {
    newContent1Src = `assets/img/contents/${$locale}/new_content4.jpg`;
    newContent2Src = `assets/img/contents/${$locale}/new_content5.jpg`;
  }
</script>

<div class="col-sm-12 col-md-12 col-lg-12 new-content-image-display">
  <div class="col-sm-12 col-md-12 col-lg-12">
    <div class="col-sm-12 col-md-4 col-lg-4 new-content-image-right">
      <img class="about-image" src={newContent1Src} alt="app introduction">
    </div>
    <div class="col-sm-12 col-md-4 col-lg-4 new-content-image">
      <img class="about-image" src={newContent2Src} alt="app introduction">
    </div>
  </div>
</div>